<label class="esf-form-item__label">{{ label }}
  <app-optional *ngIf="optional"></app-optional>
</label>
<input type="text"
       class="esf-form-item__field"
       [placeholder]="placeholder"
       [formControl]="formControl"
       [id]="id"
       (change)="checkForWhitespace($event)">
